/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedTime } from 'react-intl';

import { useParseDate } from '../../hooks/useDates';

const propTypes = {
    dateTime: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const Time = ({ dateTime, className }) => {
    if (dateTime === null) {
        return null;
    }
    const parsedDate = useParseDate(dateTime);
    return (
        <time
            dateTime={dateTime}
            className={classNames([
                {
                    [className]: className !== null,
                },
            ])}
        >
            <FormattedTime value={parsedDate} />
        </time>
    );
};

Time.propTypes = propTypes;
Time.defaultProps = defaultProps;

export default Time;
